import { Component, Inject, Injectable, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

enum SiteComponents {
  filesystem_db = 'FILESYSTEM_DB',
  filesystem = 'FILESYSTEM',
}

export interface PushToLiveOptions {
  pushLive: boolean;
  siteComponents: SiteComponents.filesystem | SiteComponents.filesystem_db;
  preserve: boolean;
}

@Component({
  selector: 'app-push-to-live-confirmation',
  templateUrl: './push-to-live-confirmation.component.html',
  styleUrls: ['./push-to-live-confirmation.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
@Injectable()
export class PushToLiveConfirmationComponent {
  confirmChecked = false;
  options: PushToLiveOptions;
  radioButtons = [
    {
      title: 'PAGES.STAGING.PUSH_PRODUCTION_MODAL.CONFIRMATION.FS_DB.DB.TITLE',
      description: 'PAGES.STAGING.PUSH_PRODUCTION_MODAL.CONFIRMATION.FS_DB.DB.DESCRIPTION',
      value: SiteComponents.filesystem_db,
    },
    {
      title: 'PAGES.STAGING.PUSH_PRODUCTION_MODAL.CONFIRMATION.FS_DB.FS.TITLE',
      description: 'PAGES.STAGING.PUSH_PRODUCTION_MODAL.CONFIRMATION.FS_DB.FS.DESCRIPTION',
      value: SiteComponents.filesystem,
    },
  ];

  constructor(
    public dialogRef: MatDialogRef<PushToLiveConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.options = {
      pushLive: false,
      siteComponents: SiteComponents.filesystem_db,
      preserve: true,
    };
  }

  submit(): void {
    this.options.pushLive = true;
    this.closeDialog();
  }

  closeDialog(): void {
    this.dialogRef.close(this.options);
  }
}
